/**
 * "/delete-account" — public account and data deletion page, reachable logged
 * in or out. Google Play links here from the FinminOS app's store listing, so
 * it must never move behind _protected. Linked from the landing footer, the
 * legal page footer and the Privacy Policy.
 */
import { createFileRoute } from '@tanstack/react-router';
import { DELETE_ACCOUNT } from '@finmin/ui';
import { LegalPage } from '@/features/legal/legal-page';

export const Route = createFileRoute('/delete-account')({
  component: () => <LegalPage doc={DELETE_ACCOUNT} />,
});
